import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./Contact.css";

function Contact() {
  const [enviado, setEnviado] = useState(false);
  const form = useRef();

  function enviarFormulario() {
    setEnviado(true);
    setTimeout(function () {
      resetearFormulario();
      setEnviado(false);
    }, 3000);
  }

  function resetearFormulario() {
    form.current.reset();
  }

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAIL_SERVICE,
        process.env.REACT_APP_EMAIL_TEMPLATE,
        form.current,
        process.env.REACT_APP_PUBLIC_KEY
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        {enviado && (
          <h2 style={{ color: "red", paddingTop: "20px" }}>Mensaje Enviado</h2>
        )}
      </div>
      <div className="contacto">
        <form ref={form} onSubmit={sendEmail}>
          <div className="form-div">
            <label style={{ color: "white" }}>Nombre Completo: </label>{" "}
            <input
              type="text"
              name="from_name"
              placeholder="Ejemplo: John Doe"
              className="input-field"
              required
            />
          </div>
          <div className="form-div">
            <label style={{ color: "white" }}>Email</label>
            <input
              type="email"
              name="email"
              placeholder="Ejemplo: correo@ejemplo.com"
              className="input-field"
              required
            />
          </div>
          <div className="form-div">
            <label style={{ color: "white" }}>Mensaje</label>
            <textarea
              name="message"
              placeholder="Tu mensaje aquí"
              className="input-field-message"
              required
            />
            
            <input type="submit" value="Enviar" onClick={enviarFormulario} />
            {enviado && <p style={{ color: "red" }}>Mensaje Enviado</p>}
          
          </div>
          
        </form>
      </div>
    </div>
  );
}

export default Contact;
